import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import RetrieveText from './components/RetrieveText';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/retrieve/:id" element={<RetrieveText />} />
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
